import { BaseGenerator } from '../core/BaseGenerator.js';

/**
 * Israeli ID generator following Single Responsibility Principle
 */
export class IlGenerator extends BaseGenerator {
  generate() {
    // Generate first 8 digits
    const digits = this.randomDigits(8);
    
    // Calculate Luhn check digit
    let sum = 0;
    
    for (let i = 0; i < 8; i++) {
      let digit = parseInt(digits[i]);
      
      // Multiply every second digit by 2
      if (i % 2 === 1) {
        digit *= 2;
        // If result is two digits, add them together
        if (digit > 9) {
          digit = Math.floor(digit / 10) + (digit % 10);
        }
      }
      
      sum += digit;
    }

    const checkDigit = (10 - (sum % 10)) % 10;
    return digits + checkDigit;
  }
}